import { useTranslation } from "react-i18next";
import AppButton from "../../../ui/buttons/AppButton";
import { appPaths } from "../../../shared/routing/appPaths";
import { editIntent, useThreadPreparation, type EditWay } from "../../threads/prepare";

interface WorkflowActionsProps {
  projectId: string;
  /** The Workflow version shown: `<item id>@<version>`. */
  reference: string;
  name: string;
}

/**
 * What the user does with a Workflow version (design review #1). Running it is the page's
 * job: a Thread is a Workflow run, so "Run this Workflow…" prepares a run with this version
 * chosen, in the Thread view beside this page (WA-11). Editing is two buttons (F116), with no
 * choice of how first: "Bearbeiten …" fills the Thread view beside this page with the Workflow
 * editor, whose Save runs the "Edit an item" step for provenance (ADR-0031 D2, F51, F113);
 * "Bearbeiten im Thread" opens a Thread with the agent, the Workflow named as its item. Which
 * steps fit the Workflow, most specific first, is offered there once the server serves it (D7).
 */
export default function WorkflowActions({ projectId, reference, name }: WorkflowActionsProps) {
  const { t } = useTranslation();
  const preparation = useThreadPreparation();
  const returnTo = appPaths.workflow(reference);
  const edit = (way: EditWay) => { preparation.prepare(editIntent(projectId, { itemKind: "workflow", name, reference }, returnTo, { way })); };
  return (
    <div className="flex flex-wrap gap-2 pt-1">
      <AppButton variant="primary" size="sm" onClick={() => { preparation.prepare({ kind: "run", projectId, returnTo, workflow: reference, entries: [], corpusVersion: null }); }}>{t("workflows.view.run")}</AppButton>
      <AppButton variant="secondary" size="sm" onClick={() => { edit("by_hand"); }}>{t("workflows.edit.open")}</AppButton>
      <AppButton variant="secondary" size="sm" onClick={() => { edit("with_the_agent"); }}>{t("workflows.edit.inThread")}</AppButton>
    </div>
  );
}
